import { render, staticRenderFns } from "./UserDepartmentTable.vue?vue&type=template&id=56e9363e&scoped=true&"
import script from "./UserDepartmentTable.vue?vue&type=script&lang=js&"
export * from "./UserDepartmentTable.vue?vue&type=script&lang=js&"
import style0 from "./UserDepartmentTable.vue?vue&type=style&index=0&id=56e9363e&lang=scss&scoped=true&"
import style1 from "./UserDepartmentTable.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56e9363e",
  null
  
)

export default component.exports